// export const baseapi =
//   "https://tawallet.transactionanalysts.com/apiwallet/api/services";

// export const frontbaseapi = "https://tawallet.transactionanalysts.com";

// export const paymentbaseapi =
//   "https://tawallet.transactionanalysts.com/apiwallet";

// export const baseapi = "http://localhost:8089/apiwallet/api/services";
// export const frontbaseapi = "http://localhost:3001";

// export const paymentbaseapi = "http://localhost:8089/apiwallet";

//////////////////////////////////////////////////////////////////////////////////////////

// export const baseapi =

//   "https://tawallet.transactionanalysts.com/apiwallet/api/services";

// export const frontbaseapi = "https://tawallet.transactionanalysts.com";

// export const paymentbaseapi =

//   "https://tawallet.transactionanalysts.com/apiwallet";

/////////////////////////////////////prod////////////////////

export const baseapi =
  "https://taapp.transactionanalysts.com:8089/apiwallet/api/services";
export const healthApi =
  "https://taapp.transactionanalysts.com:8089/apiwallet/actuator";

export const frontbaseapi = "https://tawallet.com";

export const paymentbaseapi =
  "https://taapp.transactionanalysts.com:8089/apiwallet";

////////////////////////////////Staging//////////////////////

// export const baseapi = "http://localhost:8089/apiwallet/api/services";
// export const healthApi = "http://localhost:8089/apiwallet/actuator";

// export const frontbaseapi = "http://localhost:3001";

// export const paymentbaseapi = "http://localhost:8089/apiwallet";

// export const baseapi = "http://192.168.1.5:8089/apiwallet/api/services";

// export const frontbaseapi = "http://192.168.1.5:3001";

// export const paymentbaseapi = "http://192.168.1.5:8089/apiwallet";

// deploymentid:  HTAOWEB280520261;
